import { map, Observable } from "rxjs";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AddNewUserRequest, AdminDashboardRequest, ApplicationData, ChangeStatusEmailRequest, CheckForNegotiatorRequest, CreateOrgRequest, DashboardRequest, NegotiatorDashboardRequest, UpdateAccessTypeRequest, UpdateCaseRequest } from "app/models/admin.model";
import { ResultResponse } from "app/models/common.model";
import { environment } from "environments/environment";
import { blob } from "stream/consumers";
import { UserService } from "app/users/user.service";
import { FormService } from "./form.service";


@Injectable()
export class AdminService {

    private currentApplicationCaseSysId?: string;
    private apiUrl = 'usanapi'; 
    // private apiUrl = environment.apiUrl; 
    constructor(
        private httpClient: HttpClient,
        private userService: UserService,
        private formService: FormService
      ) {}

    public getCurrentApplicationCaseSysId(): string | undefined {
    return this.currentApplicationCaseSysId;
    }

    public setCurrentApplicationCaseSysId(caseSysId: string) {
        this.currentApplicationCaseSysId = caseSysId;
    }

    public clearCurrentApplicationCaseSysId() {
        this.currentApplicationCaseSysId = undefined;
    }
    
    getOrgAdminDashboard(request: DashboardRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/dashboard/orgadmin', request);
    }

    getOrgAdminUsers(userEmail: string, userUniqueId: string, request: DashboardRequest): Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/users', request, {headers} ); 
    } 

    retrieveApplication(formType: string, sysId: string): Observable<ResultResponse> {
        let request = {
            'caseSysId' : sysId,
            'formType' : formType
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/retrieve-case', request);         
    }

    editAccess(request: UpdateAccessTypeRequest, userEmail: string, userUniqueId: string) : Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/users/permissions', request, {headers});         
    }

    removeUser(orgId: string, email: string, userEmail: string, userUniqueId: string): Observable<ResultResponse> {
        let request = {
            'emailAddress' : email
        }
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }
        let httpParams = new HttpParams();
        httpParams = httpParams.append('orgId', orgId);
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/users/remove', request, {headers, params: httpParams});         
    }

    addNewUser(orgId: string, request: AddNewUserRequest, userEmail: string, userUniqueId: string): Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }
        let httpParams = new HttpParams();
        httpParams = httpParams.append('orgId', orgId);
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/users/add', request, {headers, params: httpParams});         
    }

    retrieveApplicationComments(sysId: string): Observable<ResultResponse> {
        let request = {
            'caseSysId' : sysId
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/case-retrieve-comments', request);         
    }

    addApplicationComments(sysId: string, newComments: string): Observable<ResultResponse> {
        let request = {
            'comments' : newComments
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/case-add-comments/' + sysId, request);         
    }

    retrieveApplicationAttachments(formType: string, sysId: string): Observable<ResultResponse> {
        let request = {
            'caseSysId' : sysId,
            'formType' : formType
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/attachments-case', request);         
    }

    updateCaseRequest(formType: string, sysId: string, request : UpdateCaseRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/update-case/' + formType + '/' + sysId, request);         
    }

    getApplicationsForAdminDashboard(request: AdminDashboardRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/dashboard/usanadmin', request);
    }

    searchOrgByName(orgName: string, userEmail: string, userUniqueId: string): Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }
        let request = {
            'organizationName': orgName,
        };
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/findbyname', request, {headers});         
    }

    getUsersForAdminDashboard(userEmail: string, userUniqueId: string): Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId,
            'content-type' : 'application/json'
        }  
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/allUsanUsers',null, {headers} ); 
    }

    createOrg(userEmail: string, userUniqueId: string, request: CreateOrgRequest): Observable<ResultResponse> {
        let headers = {
            'x-mail': userEmail,
            'x-amauniqueid' : userUniqueId
        }  
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/create',request, {headers} ); 
    }

    downloadAttachment(attachSysId: string): Observable<Blob>{
        let request = {
            'attachSysId' : attachSysId
        }
        const options = {
            responseType : 'blob' as 'json'
        }
        return this.httpClient.post<Blob>(this.apiUrl + '/download/attachment', request,options)
    }

    searchNegotiator(firstName: string, lastName: string): Observable<ResultResponse> {
        let request = {
            'firstName' : firstName,
            'lastName' : lastName
        }
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/negotiators', request);
    }

    getNegotiatorDashBoard(request: NegotiatorDashboardRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/dashboard/negotiator', request); 
    }

	sendChangeStatusEmailNotification(request : ChangeStatusEmailRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/notifications/email/change-status', request);         
    }

    checkForUSANNegotiator(request : CheckForNegotiatorRequest): Observable<ResultResponse> {
        return this.httpClient.post<ResultResponse>(this.apiUrl + '/org/isUsanNegotiatorForOrg', request);         
    }

    public isApplicationLocked(appData: ApplicationData) {
        // No lock by user sso id or lock sso id is the same as the user's sso id.
        if(!appData.lockedById || appData.lockedById === this.userService.profile?.uniqueId) {
          return false;
        }
    
        return this.formService.isTimeStampLessThanLockTimeout(Number(appData.lastLockedTime));
      }
}